module.exports = __webpack_public_path__ + "static/banner-8d3c7a12a5aa097addcbc6898b7baf9a.png";